/** Whether a filter field value should be treated as “active” for chips and API body. */
export function isFilterValueActive(v: unknown): boolean {
  if (v === undefined || v === null || v === "") return false;
  if (Array.isArray(v)) return v.length > 0;
  return true;
}
